import navigationActions from '../actions/navigationActions';
import {getNavTabs} from '../selectors/navigation';

function setActiveNavTab(store) {
    const state = store.getState();
    const navTabs = getNavTabs(state);

    for (let [index, tab] of navTabs.entries()) {
        if (state.navigationReducer.waypointsInView.get(tab.id)) {
            store.dispatch(navigationActions.navSetActiveTab(index));
            return;
        }
    }
}

export {setActiveNavTab};
